(() => {
  const preserveParams = link => {
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin) return;
    const current = new URLSearchParams(window.location.search);
    for (const [key, value] of current) if (key.startsWith('utm_') || ['preview_theme_id', 'weight', 'plan'].includes(key)) url.searchParams.set(key, value);
    link.href = url.href;
  };
  const initializeLinks = root => root.querySelectorAll('[data-funnel-link]').forEach(preserveParams);
  initializeLinks(document);
  document.addEventListener('shopify:section:load', event => initializeLinks(event.target));
  document.querySelectorAll('[data-formula]').forEach(button => button.addEventListener('click', () => {
    const formula = button.dataset.formula;
    document.querySelectorAll('[data-formula]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    document.querySelectorAll('[data-active-amount]').forEach(item => { item.textContent = item.dataset[formula]; });
  }));
  if (customElements.get('mwf-offer')) return;
  class MrWuffOffer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-offer-data]').textContent);
      this.form = this.querySelector('[data-offer-form]');
      this.weight = '0-16'; this.plan = 'short'; this.busy = false;
      const requested = new URLSearchParams(window.location.search);
      const legacyWeights = {'0-35':'0-16','36-65':'16-29','65-100':'30-plus','66-100':'30-plus','100-120':'30-plus','101-120':'30-plus','over-120':'30-plus','30-45':'30-plus','46-54':'30-plus','over-54':'30-plus'};
      if (legacyWeights[requested.get('weight')]) requested.set('weight', legacyWeights[requested.get('weight')]);
      if (this.data.plans.some(row => row.slug === requested.get('weight'))) this.weight = requested.get('weight');
      if (['short', 'long'].includes(requested.get('plan'))) this.plan = requested.get('plan');
      this.querySelectorAll('[data-weight]').forEach(button => button.addEventListener('click', () => { this.weight = button.dataset.weight; this.update(); }));
      this.querySelectorAll('[name="intro_plan"]').forEach(input => input.addEventListener('change', () => { this.plan = input.value; this.update(); }));
      this.form.addEventListener('submit', event => { event.preventDefault(); this.purchase(false); });
      this.querySelector('[data-buy-once]').addEventListener('click', () => this.purchase(true));
      const allSlides = Array.from(this.querySelectorAll('.mwf-gallery__slide'));
      const allDots = Array.from(this.querySelectorAll('[data-gallery-index]'));
      this.slides = [];
      this.dots = [];
      allSlides.forEach((slide, index) => {
        const dot = allDots[index];
        if (!slide.querySelector('img,video')) { slide.remove(); dot?.closest('li')?.remove(); return; }
        if (dot) { dot.dataset.galleryIndex = String(this.slides.length); this.dots.push(dot); }
        this.slides.push(slide);
      });
      this.querySelectorAll('[data-gallery-next],[data-gallery-previous]').forEach(button => { button.hidden = this.slides.length < 2; });
      this.galleryViewport = this.querySelector('.wf-oh-mainbox');
      this.slide = 0;
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.showSlide(this.slide + 1));
      this.querySelector('[data-gallery-previous]').addEventListener('click', () => this.showSlide(this.slide - 1));
      this.dots.forEach(button => button.addEventListener('click', () => this.showSlide(Number(button.dataset.galleryIndex))));
      this.galleryViewport?.addEventListener('scroll', () => {
        if (!this.slides.length) return;
        const width = this.slides[0].getBoundingClientRect().width + (window.innerWidth < 1024 ? 8 : 0);
        this.slide = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.galleryViewport.scrollLeft / width)));
        this.updateGalleryButtons();
      }, {passive: true});
      this.update();
    }
    subscriptionAvailable(row) { return Boolean(row.available && row.sellingPlan && row.pricingVerified && row.renewalCents === row.priceCents && this.data.shippingEnabled); }
    setMoney(element, value, template = '__PRICE__') {
      element.replaceChildren();
      template.split('__PRICE__').forEach((part, index) => {
        if (index) {
          const price = document.createElement('span');
          price.className = 'money';
          price.textContent = value;
          element.append(price);
        }
        element.append(document.createTextNode(part));
      });
    }
    fill(template, values) { return Object.entries(values).reduce((text, [key, value]) => text.replaceAll('__' + key + '__', value), template); }
    showSlide(index) {
      if (!this.slides.length) return;
      this.slide = (index + this.slides.length) % this.slides.length;
      if (this.galleryViewport) {
        const target = this.slides[this.slide];
        this.galleryViewport.scrollTo({left: target.offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth'});
      } else this.slides.forEach((slide, i) => { slide.hidden = i !== this.slide; });
      this.updateGalleryButtons();
    }
    updateGalleryButtons() {
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-pressed', String(i === this.slide));
        dot.setAttribute('aria-current', String(i === this.slide));
        dot.classList?.toggle('wf-oh-thumb-on', i === this.slide);
      });
    }
    update() {
      const strings = this.data.strings;
      this.querySelectorAll('[data-weight]').forEach(button => {
        const selected = button.dataset.weight === this.weight;
        button.setAttribute('aria-pressed', String(selected));
        button.setAttribute('aria-checked', String(selected));
        button.classList?.toggle('wf-oh-weight-on', selected);
      });
      this.querySelectorAll('[data-plan-card]').forEach(card => {
        const selected = card.dataset.planCard === this.plan;
        card.setAttribute('aria-checked', String(selected));
        card.classList.toggle('wf-oh-plan-on', selected);
        card.querySelector('.wf-oh-plan-tag')?.classList.toggle('wf-oh-plan-tag-off', !selected);
        card.querySelector('.wf-oh-plan-body')?.classList.toggle('wf-oh-plan-body-off', !selected);
        card.querySelector('.wf-oh-plan-closed')?.classList.toggle('wf-oh-plan-closed-on', selected);
        card.querySelector('.wf-oh-radio')?.classList.toggle('wf-oh-radio-on', selected);
        const dot = card.querySelector('.wf-oh-radio-dot');
        if (dot) dot.hidden = !selected;
      });
      const rows = this.data.plans.filter(row => row.slug === this.weight);
      for (const row of rows) {
        const text = (name, value) => { this.querySelector('[data-plan-' + name + '="' + row.plan + '"]').textContent = value; };
        text('title', this.fill(strings.plan_name, {DAYS: row.days, TUBS: row.tubs}).replace('(1 Tubs)', '(1 Tub)'));
        this.setMoney(this.querySelector('[data-plan-per-day="' + row.plan + '"]'), row.perDayFormatted, strings.per_day);
        text('saving', this.fill(strings.discount, {PERCENT: Math.round((1 - row.priceCents / row.compareAtCents) * 100)}));
        text('supply', this.fill(strings.supply, {DAYS: row.days}));
        this.setMoney(this.querySelector('[data-plan-price="' + row.plan + '"]'), row.priceFormatted);
        this.setMoney(this.querySelector('[data-plan-was="' + row.plan + '"]'), row.onceFormatted);
      }
      this.selected = rows.find(row => row.plan === this.plan);
      const row = this.selected;
      this.querySelectorAll('[name="intro_plan"]').forEach(input => { input.checked = input.value === this.plan; });
      this.querySelector('[data-variant]').value = row.variant;
      this.querySelector('[data-quantity]').value = row.qty;
      this.querySelector('[data-selling-plan]').value = row.sellingPlan || '';
      this.querySelector('[data-selling-plan]').disabled = !row.sellingPlan;
      const active = this.subscriptionAvailable(row);
      this.setMoney(this.querySelector('[data-buy-once]'), row.onceFormatted, strings.buy_once);
      this.querySelector('[data-buy-once]').disabled = !row.available || !row.oncePricingVerified;
      this.querySelector('[data-checkout]').disabled = !active;
      if (active) this.setMoney(this.querySelector('[data-checkout]'), row.priceFormatted, strings.checkout);
      else this.querySelector('[data-checkout]').textContent = strings.unavailable;
      if (active && document.createElement) {
        const strike = document.createElement('span'); strike.className = 'wf-oh-cta-strike'; this.setMoney(strike, row.onceFormatted);
        this.querySelector('[data-checkout]').append(' ', strike);
      }
      this.querySelector('[data-availability]').hidden = active;
      this.querySelector('[data-availability]').textContent = strings.unavailable_note;
      const stock = this.querySelector('[data-stock]'); if (stock) stock.hidden = !row.available;
      document.querySelectorAll('[data-comparison-per-day]').forEach(item => { this.setMoney(item, row.perDayFormatted); });
      if (typeof window.bucksCC?.reConvert === 'function') window.bucksCC.reConvert();
      const url = new URL(window.location.href); url.searchParams.set('weight', this.weight); url.searchParams.set('plan', this.plan); window.history.replaceState(null, '', url);
    }
    async purchase(once) {
      if (this.busy) return;
      const row = this.selected;
      if (!row.available || (once && !row.oncePricingVerified) || (!once && !this.subscriptionAvailable(row))) return;
      const error = this.querySelector('[data-error]'); error.hidden = true;
      const button = this.querySelector(once ? '[data-buy-once]' : '[data-checkout]');
      this.busy = true; button.disabled = true; button.textContent = this.data.strings.loading;
      this.querySelectorAll('[data-weight], [name="intro_plan"]').forEach(item => { item.disabled = true; });
      try {
        const item = {id: row.variant, quantity: row.qty};
        if (!once) item.selling_plan = row.sellingPlan;
        const response = await fetch(this.data.cartAddUrl, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [item], ...(window.MrwCart?.requestData() || {})})});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || this.data.strings.cart_error);
        if (window.MrwCart) await window.MrwCart.afterAdd(result, button);
        else window.location.assign(this.data.rootUrl + 'cart');
      } catch (problem) {
        error.textContent = problem.message || this.data.strings.cart_error; error.hidden = false;
      } finally {
        this.busy = false; this.update();
        this.querySelectorAll('[data-weight], [name="intro_plan"]').forEach(item => { item.disabled = false; });
      }
    }
  }
  customElements.define('mwf-offer', MrWuffOffer);
})();



